var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "white",
    stroke: "#685879"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5858 13.2518C14.9609 12.8767 15.4696 12.666 16 12.666H21.3333C21.5101 12.666 21.6797 12.7363 21.8047 12.8613L25.8047 16.8613C25.9298 16.9863 26 17.1559 26 17.3327V25.3327C26 25.8631 25.7893 26.3718 25.4142 26.7469C25.0391 27.122 24.5304 27.3327 24 27.3327H16C15.4696 27.3327 14.9609 27.122 14.5858 26.7469C14.2107 26.3718 14 25.8631 14 25.3327V14.666C14 14.1356 14.2107 13.6269 14.5858 13.2518ZM16 13.9993C15.8232 13.9993 15.6536 14.0696 15.5286 14.1946C15.4036 14.3196 15.3333 14.4892 15.3333 14.666V25.3327C15.3333 25.5095 15.4036 25.6791 15.5286 25.8041C15.6536 25.9291 15.8232 25.9993 16 25.9993H24C24.1768 25.9993 24.3464 25.9291 24.4714 25.8041C24.5964 25.6791 24.6667 25.5095 24.6667 25.3327V17.9993H21.3333C20.9651 17.9993 20.6667 17.7009 20.6667 17.3327V13.9993H16ZM22 14.9422L23.7239 16.666H22V14.9422ZM17.3333 19.9993C16.9651 19.9993 16.6667 20.2978 16.6667 20.666C16.6667 21.0342 16.9651 21.3327 17.3333 21.3327H22.6667C23.0349 21.3327 23.3333 21.0342 23.3333 20.666C23.3333 20.2978 23.0349 19.9993 22.6667 19.9993H17.3333ZM16.6667 23.3327C16.6667 22.9645 16.9651 22.666 17.3333 22.666H22.6667C23.0349 22.666 23.3333 22.9645 23.3333 23.3327C23.3333 23.7009 23.0349 23.9993 22.6667 23.9993H17.3333C16.9651 23.9993 16.6667 23.7009 16.6667 23.3327ZM17.3333 17.3327C16.9651 17.3327 16.6667 17.6312 16.6667 17.9993C16.6667 18.3675 16.9651 18.666 17.3333 18.666H18.6667C19.0349 18.666 19.3333 18.3675 19.3333 17.9993C19.3333 17.6312 19.0349 17.3327 18.6667 17.3327H17.3333Z",
    fill: "#190134"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/FileIcon.f07ddc71929f345e57d3f86c62a515a9.svg";
export { ForwardRef as ReactComponent };